module.exports = __webpack_public_path__ + "static/media/Formato_Actualizar_documentos_repare.eb97054e.xlsx";